import App from '../../containers/App'
import ProductArea from '../../containers/ProductArea'
import {
  simpleData,
  variableData,
  bundleData,
  demoData,
  Container,
  Content, 
  GlobalStyles, 
  StyleSheets,
  Header, 
  HeaderRow, 
  DemoContent,
  DemoLogo,
} from '../demo-utils'

const AppDemo = () => (<> 
    <StyleSheets url={demoData.config.stylesheetURL} />
    <GlobalStyles fontFamily={demoData.config.fontFamily} />
    <Container>
      <App /> 
    </Container>
</>)

export default AppDemo
